const ml = {
  // Header
  address: "വിലാസം",
  home: "ഹോം",
  about: "ഞങ്ങളെ കുറിച്ച്",
  schemes: "പദ്ധതികൾ",
  howItWorks: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
  login: "ലോഗിൻ",
  logout : "ലോഗ്‌ഔട്ട്",

  // Banner
  bannerTitle: "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം",
  bannerTagline: "ആശ്രിതർക്ക് ആശ്വാസം , സംഘങ്ങൾക്ക് പരിരക്ഷ",
  bannerSubtitle: "റിസ്‌ക് & വെൽഫെയർ പദ്ധതികൾ ഏകീകൃതമായി കൈകാര്യം ചെയ്യാനുള്ള ഒരു ഡിജിറ്റൽ പ്ലാറ്റ്‌ഫോം.",
  readMore: "കൂടുതൽ വായിക്കുക",

  // About service cards
  riskFundBeneficiaries: "റിസ്ക് ഫണ്ട് ഗുണഭോക്താക്കൾ",
  riskFundBeneficiariesDesc:
    "മരണം, അപകടം അല്ലെങ്കിൽ വൈകല്യ ക്ലെയിമുകൾക്ക് അപേക്ഷിക്കുകയും സ്ഥിതി ട്രാക്ക് ചെയ്യുകയും ചെയ്യുക",
  applyForClaim: "ക്ലെയിമിന് അപേക്ഷിക്കുക",
  societiesAndBanks: "സൊസൈറ്റികളും ബാങ്കുകളും",
  societiesAndBanksDesc:
    "അംഗങ്ങളുടെ സംഭാവനകളും ക്ഷേമ പ്രവർത്തനങ്ങളും കൈകാര്യം ചെയ്യുന്ന രജിസ്റ്റർ ചെയ്ത സ്ഥാപനങ്ങൾ",
  registerSociety: "സൊസൈറ്റി രജിസ്റ്റർ ചെയ്യുക",

  // About section
  aboutUsLabel: "ഞങ്ങളെ കുറിച്ച്",
  aboutRWFMS: "ആർ.ഡബ്ല്യു.എഫ്.എം.എസ് നെ കുറിച്ച്",
  aboutDesc:
    "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം (RWFMS) ഗുണഭോക്താക്കൾക്കും സഹകരണ സ്ഥാപനങ്ങൾക്കും റിസ്ക് & വെൽഫെയർ പദ്ധതികൾ കാര്യക്ഷമമായി ഉപയോഗിക്കാനും നിയന്ത്രിക്കാനും സഹായിക്കുന്നു.",
  digitalProcessing: "ഡിജിറ്റൽ പ്രോസസ്സിങ്",
  digitalProcessingDesc:
    "അപേക്ഷയുടെ തുടക്കം മുതൽ അവസാനം വരെ മുഴുവൻ നടപടികളും ഓൺലൈനായി നടത്തി രേഖാപ്രക്രിയകൾ ഒഴിവാക്കുന്നു.",
  transparentGovernance: "സുതാര്യമായ സംവിധാനം",
  transparentGovernanceDesc:
    "ഓരോ ഇടപാടിനും തത്സമയ സ്റ്റാറ്റസ് ട്രാക്കിംഗും സമഗ്രമായ പൊതുജന പരിശോധനാ സൗകര്യവും ഉറപ്പാക്കുന്നു.",
  swiftDisbursement: "വേഗത്തിലുള്ള വിതരണം",
  swiftDisbursementDesc:
    "അർഹമായ സഹായ തുക വൈകാതെ, യാതൊരു തടസ്സവും ഇല്ലാതെ, സുരക്ഷിതമായി ബന്ധപ്പെട്ട സൊസൈറ്റിയുടെ ബാങ്ക് അക്കൗണ്ടിലേക്ക് സമയബന്ധിതമായി കൈമാറുന്നു.",

  // Schemes section
  schemesCovered: "ഉൾപ്പെടുന്ന പദ്ധതികൾ",
  riskFundSchemes: "റിസ്ക് ഫണ്ട് പദ്ധതികൾ",
  riskFundSchemesDesc:
"റിസ്‌ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്മെന്റ് സംവിധാനം, കൈമാറ്റ രീതിയിൽ നടന്നിരുന്ന നടപടികളെ സുരക്ഷിതവും പൂർണ്ണമായും ഡിജിറ്റൽ രീതിയിലേക്കാണ് മാറ്റുന്നത്. ഇത് കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡിന്നുവേണ്ടി ഒരുക്കിയ പ്ലാറ്റ്‌ഫോമാണ്. ഗുണഭോക്താക്കൾക്ക് അവരുടെ അർഹമായ സഹായം വൈകാതെ, പരമാവധി സുതാര്യതയോടെ ലഭ്യമാക്കുന്നതാണ് ഈ സംവിധാനത്തിന്റെ ലക്ഷ്യം.റിസ്‌ക് ഫണ്ട് പദ്ധതിയിലെ അംഗത്വം, പ്രീമിയം പേയ്മെന്റുകൾ എന്നിവ സൊസൈറ്റികൾ ഈ പ്ലാറ്റ്‌ഫോമിലൂടെ കൈകാര്യം ചെയ്യുന്നു. പൊതുജന ഗുണഭോക്താക്കൾക്ക് ഇവിടെ നിന്ന് ക്ലെയിം അപേക്ഷിക്കാനും സ്റ്റാറ്റസ് പരിശോധിക്കാനും കഴിയും.",
  deathClaimSupport: "മരണ അപേക്ഷ സഹായം",
  deathClaimDesc:
    "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം കേരള സഹകരണ വികസന & വെൽഫെയർ ഫണ്ട് ബോർഡിന് ആയി മാനുവൽ പ്രക്രിയകൾ സുരക്ഷിതവും പേപ്പർരഹിതവുമായ ഡിജിറ്റൽ അന്തരീക്ഷത്തിലേക്ക് മാറ്റുന്നു. ഗുണഭോക്താക്കൾക്ക് അർഹമായ പിന്തുണ കാലതാമസമില്ലാതെ ലഭിക്കുന്നു എന്ന് ഉറപ്പാക്കുക ആണ് ഞങ്ങളുടെ ലക്ഷ്യം.",
  treatmentClaimSupport: "ചികിത്സ അപേക്ഷ സഹായം",
  treatmentClaimDesc:
    "ഗുരുതരമായ, ജീവൻ അപകടകരമായ അസുഖം ബാധിച്ച അംഗങ്ങൾക്ക് സാമ്പത്തിക സഹായം.",

  // Welfare section
  welfareFundSchemes: "വെൽഫെയർ ഫണ്ട് പദ്ധതികൾ",
  welfareFundSchemesDesc:
    "വെൽഫെയർ ഫണ്ട് പദ്ധതി, സാമ്പത്തികമായി ദുർബലരായ സഹകരണ സൊസൈറ്റികളെ പുനരുജ്ജീവിപ്പിക്കുകയും ശക്തിപ്പെടുത്തുകയും ചെയ്യുന്നതിനായി രൂപകൽപ്പന ചെയ്തിട്ടുള്ളതാണ്. സാമ്പത്തിക നഷ്ടം ഉണ്ടാകുന്ന സന്ദർഭത്തിൽ വായ്പ സഹായം ലഭിക്കുന്നതിനും കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡ് (KCDWFB) നൽകുന്ന സേവനങ്ങൾ പ്രയോജനപ്പെടുത്തുന്നതിനും സൊസൈറ്റികൾ ഈ പദ്ധതിയിൽ ചേർന്ന് അംഗത്വം നേടേണ്ടതാണ്. ഈ പോർട്ടലിലൂടെ, സൊസൈറ്റികൾക്ക് പുതിയ അംഗത്വം എടുക്കാനും, നിലവിലുള്ള അംഗത്വം സജീവമാക്കാനും, വാർഷിക സംഭാവനകൾ അടയ്ക്കാനും, പുതുക്കൽ പേയ്മെന്റുകൾ നടത്താനും സാധിക്കും. ഇത് ആവശ്യമുള്ള ഏത് സന്ദർഭത്തിലും ബോർഡിൽ നിന്ന് സാമ്പത്തിക സഹായം ലഭിക്കുന്നതിനുള്ള തുടർ അർഹത ഉറപ്പാക്കുന്നു.",
  societyEnrollment: "സൊസൈറ്റി എൻറോൾമെന്റ്",
  societyEnrollmentDesc:
    "കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡിന്റെ ക്ഷേമ പദ്ധതികളിൽ സൊസൈറ്റികൾ ചേരുന്നതിനുള്ള ലളിതമായ പ്രക്രിയ.",
  annualRenewal: "വാർഷിക പുതുക്കൽ",
  annualRenewalDesc:
    "വാർഷിക അംഗത്വ പരിപാലനത്തിനായി ഓട്ടോമേറ്റഡ് ഓർമ്മപ്പെടുത്തലുകളും ലളിതമായ പേയ്‌മെന്റ് ഗേറ്റ്‌വേകളും.",

  // How it Works
  howItWorksLabel: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
  easySteps: "ജോലി പ്രക്രിയയുടെ ലളിതമായ 4 ഘട്ടങ്ങൾ",
  register: "രജിസ്റ്റർ",
  registerDesc: "ഗുണഭോക്താവ് അല്ലെങ്കിൽ സൊസൈറ്റി ആയി സൈൻ അപ്പ് ചെയ്യുക.",
  submitClaim: "അപേക്ഷ സമർപ്പിക്കുക",
  submitClaimDesc: "ആവശ്യമായ രേഖകൾ ഓൺലൈനായി അപ്‌ലോഡ് ചെയ്യുക.",
  verification: "പരിശോധന",
  verificationDesc: "സൊസൈറ്റി, വകുപ്പ് & ബോർഡ് തലത്തിൽ സ്ഥിരീകരണം.",
  disbursement: "തുക ലഭിക്കൽ",
  disbursementDesc: "അംഗീകരിച്ച തുക നേരിട്ട് സൊസൈറ്റി ബാങ്ക് അക്കൗണ്ടിലേക്ക് ലഭിക്കും.",

  // New Registration page
  newRegistration: "പുതിയ രജിസ്ട്രേഷൻ",
  newRegSubtitle: "നിങ്ങളുടെ അക്കൗണ്ട് തുടങ്ങാൻ വിശദാംശങ്ങൾ നൽകുക.",
  applicantFullName: "അപേക്ഷകന്റെ പൂർണ്ണ നാമം",
  emailAddress: "ഇമെയിൽ വിലാസം",
  verifyRegister: "സ്ഥിരീകരിച്ച് രജിസ്റ്റർ ചെയ്യുക",
  alreadyHaveAccount: "ഇതിനകം അക്കൗണ്ട് ഉണ്ടോ?",
  loginHere: "ഇവിടെ ലോഗിൻ ചെയ്യുക",

  // Login page
  loginWelcome: "സ്വാഗതം",
  loginSubtitle: "നിങ്ങളുടെ റിസ്ക് ഫണ്ട് അക്കൗണ്ട് സുരക്ഷിതമായി ആക്സസ് ചെയ്യുക",
  mobileNumber: "മൊബൈൽ നമ്പർ",
  enterMobileNumber: "മൊബൈൽ നമ്പർ നൽകുക",
  sendOtp: "ഒടിപി അയക്കുക",
  sending: "അയക്കുന്നു...",
  enter6DigitOtp: "6 അക്ക ഒടിപി നൽകുക",
  dontReceiveCode: "കോഡ് ലഭിച്ചില്ലേ?",
  resend: "വീണ്ടും അയക്കുക",
  verifyOtp: "ഒടിപി സ്ഥിരീകരിക്കുക",
  verifying: "സ്ഥിരീകരിക്കുന്നു...",
  newUser: "പുതിയ ഉപയോക്താവോ?",
  registerHere: "ഇവിടെ രജിസ്റ്റർ ചെയ്യുക",

  // Registration page
  societyAccountCreation: "സൊസൈറ്റി അക്കൗണ്ട് ക്രിയേഷൻ",
  societyRegSubtitle: "RWFMS സൊസൈറ്റി രജിസ്ട്രേഷൻ പൂർത്തിയാക്കി അഡ്മിൻ പോർട്ടൽ ആക്സസ് ചെയ്യുക",
  identification: "തിരിച്ചറിയൽ",
  societyDetails: "സൊസൈറ്റി വിശദാംശങ്ങൾ",
  secretaryDetails: "സെക്രട്ടറി വിശദാംശങ്ങൾ",
  societyIdentification: "സൊസൈറ്റി തിരിച്ചറിയൽ",
  societyCategory: "സൊസൈറ്റി വിഭാഗം",
  loadingCategories: "വിഭാഗങ്ങൾ ലോഡ് ചെയ്യുന്നു...",
  selectCategory: "വിഭാഗം തിരഞ്ഞെടുക്കുക",
  societyDistrict: "സൊസൈറ്റി ജില്ല",
  loadingDistricts: "ജില്ലകൾ ലോഡ് ചെയ്യുന്നു...",
  selectDistrict: "ജില്ല തിരഞ്ഞെടുക്കുക",
  societyTaluk: "സൊസൈറ്റി താലൂക്ക്",
  loadingTaluks: "താലൂക്കുകൾ ലോഡ് ചെയ്യുന്നു...",
  selectDistrictFirst: "ആദ്യം ജില്ല തിരഞ്ഞെടുക്കുക",
  selectTaluk: "താലൂക്ക് തിരഞ്ഞെടുക്കുക",
  branchCode: "ബ്രാഞ്ച് കോഡ്",
  registrationNumber: "രജിസ്ട്രേഷൻ നമ്പർ",
  enterBranchCode: "ബ്രാഞ്ച് കോഡ് നൽകുക",
  enterRegistrationNumber: "രജിസ്ട്രേഷൻ നമ്പർ നൽകുക",
  societyName: "സൊസൈറ്റി പേര്",
  rcsUniqueCode: "RCS യൂണിക് കോഡ്",
  registeredEmailId: "രജിസ്ട്രേഡ് ഇമെയിൽ ഐഡി",
  verified: "സ്ഥിരീകരിച്ചു",
  emailVerification: "ഇമെയിൽ സ്ഥിരീകരണം",
  otpSentToEmail: "നിങ്ങളുടെ രജിസ്ട്രേഡ് ഇമെയിൽ വിലാസത്തിലേക്ക് ഒടിപി അയച്ചിരിക്കുന്നു",
  resendOtp: "ഒടിപി വീണ്ടും അയക്കുക",
  verify: "സ്ഥിരീകരിക്കുക",
  secretaryName: "സെക്രട്ടറിയുടെ പേര്",
  fullLegalName: "പൂർണ്ണ നിയമപരമായ പേര്",
  enterMobileNumberPlaceholder: "മൊബൈൽ നമ്പർ നൽകുക",
  enterPassword: "പാസ്‌വേഡ് നൽകുക",
  passwordHint: "പാസ്‌വേഡിൽ കുറഞ്ഞത് 1 വലിയ അക്ഷരം, 1 ചെറിയ അക്ഷരം, 1 അക്കം, 1 പ്രത്യേക അക്ഷരം (@$!%*?&) ഉം കുറഞ്ഞത് 8 അക്ഷരങ്ങളും ഉണ്ടായിരിക്കണം.",
  confirmPassword: "പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
  declarationText: "ഞാൻ ഇതിനാൽ പ്രഖ്യാപിക്കുന്നത് നൽകിയ വിവരങ്ങൾ എന്റെ അറിവിൻ്റെ അടിസ്ഥാനത്തിൽ ശരിയാണ്, ഈ സൊസൈറ്റി അഡ്മിൻ പോർട്ടലിൽ രജിസ്റ്റർ ചെയ്യാൻ ഞാൻ അധികൃതനാണ്.",
  registrationSubmittedSuccessfully: "രജിസ്ട്രേഷൻ വിജയകരമായി സമർപ്പിച്ചു",
  bankRegSuccess: "നിങ്ങളുടെ ബാങ്ക് രജിസ്ട്രേഷൻ വിജയകരമായി പൂർത്തിയായി.",
  societyRegSuccess: "നിങ്ങളുടെ സൊസൈറ്റി രജിസ്ട്രേഷൻ വിജയകരമായി പൂർത്തിയായി.",
  loginDetailsSentEmail: "ലോഗിൻ വിശദാംശങ്ങൾ നിങ്ങളുടെ രജിസ്ട്രേഡ് ഇമെയിൽ വിലാസത്തിലേക്ക് അയച്ചിരിക്കുന്നു. നിങ്ങളുടെ അക്കൗണ്ട് ആക്സസ് ചെയ്യാൻ ഇമെയിൽ പരിശോധിക്കുക.",
  goHome: "ഹോം പേജിലേക്ക്",
  saveAndContinue: "സേവ് ചെയ്ത് തുടരുക",
  registerBtn: "രജിസ്റ്റർ ചെയ്യുക",
  back: "തിരിച്ച്",

  // User Dashboard
  myClaimsDashboard: "എന്റെ ക്ലെയിം ഡാഷ്‌ബോർഡ്",
  dashboardSubtitle: "നിങ്ങളുടെ സർക്കാർ ക്ഷേമ റിസ്ക് ഫണ്ട് അപേക്ഷകൾ കൈകാര്യം ചെയ്യുകയും ട്രാക്ക് ചെയ്യുകയും ചെയ്യുക.",
  startNewClaim: "പുതിയ ക്ലെയിം ആരംഭിക്കുക",
  startNewClaimDesc: "പുതിയ അപേക്ഷ സമർപ്പിക്കാൻ തയ്യാറാണോ? നിങ്ങളുടെ ലോൺ വിശദാംശങ്ങൾ തയ്യാറായിട്ടുണ്ടെന്ന് ഉറപ്പാക്കുക.",
  applyNewClaim: "പുതിയ ക്ലെയിമിന് അപേക്ഷിക്കുക",
  myClaims: "എന്റെ ക്ലെയിമുകൾ",
  claimId: "ക്ലെയിം ഐഡി",
  loaneeName: "വായ്പക്കാരൻ്റെ പേര്",
  loanNumber: "ലോൺ നമ്പർ",
  claimType: "ക്ലെയിം തരം",
  status: "സ്ഥിതി",
  actions: "നടപടികൾ",
  loadingClaims: "ക്ലെയിമുകൾ ലോഡ് ചെയ്യുന്നു...",
  noClaimsYet: "ഇതുവരെ ക്ലെയിമുകൾ ഒന്നും സമർപ്പിച്ചിട്ടില്ല.",
  draft: "ഡ്രാഫ്റ്റ്",
  submitted: "സമർപ്പിച്ചു",
  resume: "തുടരുക",
  loading: "ലോഡ് ചെയ്യുന്നു...",
  delete: "നീക്കുക",
  view: "കാണുക",
  failedToLoad: "ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",
  prev: "പിന്നിലേക്ക്",
  next: "അടുത്തത്",
  importantInformation: "പ്രധാനപ്പെട്ട വിവരങ്ങൾ",
  claimVerificationNote: "ക്ലെയിം സൊസൈറ്റി സെക്രട്ടറി / ബാങ്ക് മാനേജർ സ്ഥിരീകരിക്കും",
  deleteDraft: "ഡ്രാഫ്റ്റ് നീക്കുക",
  deleteDraftConfirm: "ഈ ഡ്രാഫ്റ്റ് ഇല്ലാതാക്കണമെന്ന് നിങ്ങൾക്ക് ഉറപ്പാണോ?",
  cancel: "റദ്ദാക്കുക",
  deleting: "നീക്കുന്നു...",

  // Loan Details
  selectActiveLoan: "സജീവ ലോൺ തിരഞ്ഞെടുക്കുക",
  selectActiveLoanSubtitle: "നിലവിലെ അപേക്ഷയ്ക്കായി പ്രോസസ്സ് ചെയ്യേണ്ട ലോൺ രേഖ തിരഞ്ഞെടുക്കുക.",
  fetchLoanError: "ലോൺ വിശദാംശങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു.",
  fetchLoanErrorRetry: "ലോൺ വിശദാംശങ്ങൾ ലഭ്യമാക്കുന്നതിൽ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",
  searchByNameOrLoan: "പേര് / ലോൺ നമ്പർ തിരയുക",
  membershipNo: "അംഗത്വ നമ്പർ",
  amount: "തുക",
  noRecordsFound: "ഇതിനായി ഒന്നും കണ്ടെത്തിയില്ല",

  // File Upload
  fileFormatHint: "jpg, pdf, png, 2MB വരെ",
  clickToBrowse: "ക്ലിക്ക് ചെയ്യുക അല്ലെങ്കിൽ വലിച്ചിടുക",
  invalidFileType: "jpg, png, pdf ഫയലുകൾ മാത്രം അനുവദനീയമാണ്.",
  fileTooLarge: "ഫയൽ വലുപ്പം 2MB ൽ കൂടരുത്.",

  // Death Claim
  deathClaimPageSubtitle: "വായ്പക്കാർക്കുള്ള മരണ ക്ലെയിം അപേക്ഷകൾ സമർപ്പിക്കുകയും കൈകാര്യം ചെയ്യുകയും ചെയ്യുക.",
  deathClaimDetails: "മരണ ക്ലെയിം വിശദാംശങ്ങൾ",
  claimantNamePlaceholder: "ആധാർ പ്രകാരം പൂർണ്ണ നാമം",
  selectRelationship: "ബന്ധം തിരഞ്ഞെടുക്കുക",
  loadRelationshipsError: "ബന്ധങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. പേജ് പുതുക്കുക.",
  specifyRelationshipPlaceholder: "വായ്പക്കാരനുമായുള്ള ബന്ധം നൽകുക",
  previousDiseaseReliefLabel: "മുൻ രോഗാശ്വാസം എടുത്തിട്ടുണ്ടോ",
  yes: "അതെ",
  no: "ഇല്ല",
  amountReceived: "ലഭിച്ച തുക (₹)",
  dodProofUpload: "മരണ തീയതി തെളിവ് അപ്‌ലോഡ്",
  uploadDodProof: "മരണ തീയതി തെളിവ് അപ്‌ലോഡ് ചെയ്യുക",
  uploadDodProofRequired: "മരണ തീയതി തെളിവ് അപ്‌ലോഡ് ചെയ്യുക.",
  deathClaimDraftSavedDesc: "നിങ്ങളുടെ മരണ ക്ലെയിം ഡ്രാഫ്റ്റ് സേവ് ചെയ്തിരിക്കുന്നു. തുടർന്ന് എഡിറ്റ് ചെയ്ത് പിന്നീട് സമർപ്പിക്കാം.",
  claimantNameRequired: "ആവശ്യപ്പെടുന്ന വ്യക്തിയുടെ നാമം.",
  relationshipRequired: "വായ്പക്കാരനുമായുള്ള ബന്ധം ആവശ്യമാണ്.",
  specifyRelationshipRequired: "ദയവായി ബന്ധം വ്യക്തമാക്കുക.",
  dateOfDeathRequired: "മരണ തീയതി ആവശ്യമാണ്.",
  deathCertRequired: "മരണ സർട്ടിഫിക്കറ്റ് നമ്പർ ആവശ്യമാണ്.",
  releaseAmountRequired: "ലഭിച്ച തുക ആവശ്യമാണ്.",
  ok: "ശരി",

  // Death Claim Preview
  previewDeathClaimTitle: "മരണ ക്ലെയിം പ്രിവ്യൂ",
  deathClaimSubmittedDesc: "നിങ്ങളുടെ മരണ ക്ലെയിം അപേക്ഷ സമർപ്പിച്ചിരിക്കുന്നു. അവസ്ഥ ഉടൻ അറിയിക്കും.",

  // Disease Claim Preview
  previewDiseaseClaimTitle: "ചികിത്സ ക്ലെയിം പ്രിവ്യൂ",
  submitting: "സമർപ്പിക്കുന്നു...",
  submit: "സമർപ്പിക്കുക",
  claimSubmittedSuccess: "ക്ലെയിം വിജയകരമായി സമർപ്പിച്ചു!",
  applicationNo: "അപേക്ഷ നമ്പർ",
  diseaseClaimSubmittedDesc: "നിങ്ങളുടെ ചികിത്സ ക്ലെയിം അപേക്ഷ സമർപ്പിച്ചിരിക്കുന്നു. അവസ്ഥ ഉടൻ അറിയിക്കും.",
  somethingWentWrong: "എന്തോ തകരാർ സംഭവിച്ചു. വീണ്ടും ശ്രമിക്കുക.",

  // Disease Claim
  diseaseClaimDetails: "ചികിത്സ ക്ലെയിം വിശദാംശങ്ങൾ",
  selectDiseaseCategory: "രോഗ വിഭാഗം തിരഞ്ഞെടുക്കുക",
  searchHospital: "ആശുപത്രി / ക്ലിനിക് തിരയുക",
  hospitalSearchFailed: "ആശുപത്രി തിരയുന്നതിൽ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",
  documentsUpload: "രേഖകൾ അപ്‌ലോഡ് ചെയ്യുക",
  additionalDocuments: "അധിക രേഖകൾ (നിർബന്ധമല്ല)",
  uploadMedicalCertificate: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് അപ്‌ലോഡ് ചെയ്യുക",
  uploadDobProof: "ജനന തീയതി തെളിവ് അപ്‌ലോഡ് ചെയ്യുക",
  chooseValidDocument: "സാധുവായ തിരിച്ചറിയൽ രേഖ",
  uploadIdProofDoc: "ഐഡി തെളിവ് രേഖ അപ്‌ലോഡ് ചെയ്യുക",
  idProofNames: {
    "PAN Card": "പാൻ കാർഡ്",
    "Passport": "പാസ്പോർട്ട്",
    "Voter ID": "വോട്ടർ ഐഡി",
    "Driving Licence": "ഡ്രൈവിംഗ് ലൈസൻസ്",
    "Birth Certificate": "ജനന സർട്ടിഫിക്കറ്റ്",
    "SSLC Certificate": "എസ്എസ്എൽസി സർട്ടിഫിക്കറ്റ്",
    "School Leaving Certificate": "സ്കൂൾ ലീവിംഗ് സർട്ടിഫിക്കറ്റ്",
    "Other Government-issued Document (Containing Date of Birth)": "മറ്റ് സർക്കാർ ഔദ്യോഗിക രേഖ (ജനന തീയതി ഉൾക്കൊള്ളുന്നത്)"
  },
  anotherDocument: "മറ്റൊരു രേഖ",
  uploadAnotherDoc: "രേഖ അപ്‌ലോഡ് ചെയ്യുക",
  anotherDocumentPlaceholder: "അപ്‌ലോഡ് ചെയ്ത രേഖയുടെ പേര് നൽകുക",
  diseaseClaimDeclText: "ഇതിനാൽ ഞാൻ പ്രഖ്യാപിക്കുന്നത്, നൽകിയ വിവരങ്ങൾ എന്റെ അറിവിൻ്റെ അടിസ്ഥാനത്തിൽ സത്യവും ശരിയുമാണ്. ഏതെങ്കിലും തെറ്റായ പ്രസ്താവന ഫണ്ട് ആനുകൂല്യങ്ങളിൽ നിന്ന് അയോഗ്യത കൽപ്പിക്കുന്നതിലേക്ക് നയിക്കാം.",
  saving: "സേവ് ചെയ്യുന്നു...",
  saveDraft: "ഡ്രാഫ്റ്റ് സേവ് ചെയ്യുക",
  previewClaim: "ക്ലെയിം പ്രിവ്യൂ",
  draftSavedTitle: "ഡ്രാഫ്റ്റ് സേവ് ചെയ്തു!",
  draftSavedDesc: "നിങ്ങളുടെ ചികിത്സ ക്ലെയിം ഡ്രാഫ്റ്റ് സേവ് ചെയ്തിരിക്കുന്നു. തുടർന്ന് എഡിറ്റ് ചെയ്ത് പിന്നീട് സമർപ്പിക്കാം.",
  diseaseCategoryRequired: "രോഗ വിഭാഗം ആവശ്യമാണ്.",
  dateOfIllnessRequired: "അസുഖം ആരംഭിച്ച തീയതി ആവശ്യമാണ്.",
  medicalCertIssuedByRequired: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് നൽകിയ ആശുപത്രി ആവശ്യമാണ്.",
  selectHospitalFromSuggestions: "ലിസ്റ്റിൽ നിന്ന് ഒരു ആശുപത്രി തിരഞ്ഞെടുക്കുക.",
  dateOfMedCertRequired: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് തീയതി ആവശ്യമാണ്.",
  uploadMedCertRequired: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് അപ്‌ലോഡ് ചെയ്യുക.",
  uploadDobProofRequired: "ജനന തീയതി തെളിവ് അപ്‌ലോഡ് ചെയ്യുക.",
  medCertDateBeforeIllness: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് തീയതി, അസുഖം ആരംഭിച്ച തീയതിക്ക് മുമ്പ് ആകരുത്.",
  saveDraftError: "ഡ്രാഫ്റ്റ് സേവ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",

  // Claim Loanee Identification
  loaneeIdentPageSubtitle: "ക്ലെയിം അപേക്ഷ തുടരാൻ വായ്പക്കാരൻ്റെ വിശദാംശങ്ങൾ നൽകുക.",
  selectClaimTypeLabel: "ക്ലെയിം തരം തിരഞ്ഞെടുക്കുക",
  diseaseClaimTitle: "ചികിത്സ ക്ലെയിം",
  diseaseClaimCardDesc: "സ്ഥിരമായ വൈകല്യം അല്ലെങ്കിൽ ദീർഘകാല രോഗം മൂലമുള്ള ക്ലെയിം.",
  deathClaimTitle: "മരണ ക്ലെയിം",
  deathClaimCardDesc: "വായ്പക്കാരൻ്റെ മരണത്തെ തുടർന്ന് സമർപ്പിക്കുന്ന ക്ലെയിം.",
  selectClaimTypeError: "ദയവായി ഒരു ക്ലെയിം തരം തിരഞ്ഞെടുക്കുക.",
  loaneeIdentificationLabel: "വായ്പക്കാരൻ്റെ തിരിച്ചറിയൽ",
  loaneeIdentNote: "വായ്പക്കാരൻ്റെ ആധാർ നമ്പർ നൽകുക, സിസ്റ്റത്തിൽ നിന്ന് വായ്പയുടെ വിവരങ്ങൾ ലഭ്യമാക്കുന്നതിനായി നൽകിയ വിവരങ്ങൾ ഭൗതിക രേഖകളുമായി പൊരുത്തപ്പെടുന്നുവെന്ന് ഉറപ്പാക്കുക.",
  loaneeAadhaarNumber: "വായ്പക്കാരൻ്റെ ആധാർ നമ്പർ",
  enterAadhaarError: "ആധാർ നമ്പർ നൽകുക.",
  invalidAadhaarError: "ആധാർ നമ്പർ കൃത്യം 12 അക്കങ്ങൾ ആയിരിക്കണം.",
  fetching: "ലഭ്യമാക്കുന്നു...",
  fetchLoans: "ലോണുകൾ കണ്ടെത്തുക",
  noLoansFound: "ഈ ആധാർ നമ്പറിന് ലോണുകളൊന്നും കണ്ടെത്തിയില്ല.",
  failedToLoadClaims: "ക്ലെയിമുകൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയപ്പെട്ടു. പേജ് പുതുക്കുക.",
  failedToDeleteDraft: "ഡ്രാഫ്റ്റ് നീക്കുന്നതിൽ പരാജയപ്പെട്ടു.",

  // Claim View Modal
  loanDetails: "ലോൺ വിശദാംശങ്ങൾ",
  loaneeFullName: "വായ്പക്കാരൻ്റെ പൂർണ്ണ നാമം",
  aadhaarNumber: "ആധാർ നമ്പർ",
  loanAmount: "ലോൺ തുക",
  societyMembership: "സൊസൈറ്റി അംഗത്വ നമ്പർ",
  societyAddress: "സൊസൈറ്റി വിലാസം",
  dateOfBirth: "ജനനതീയതി",
  birthCertificate: "ജനന സർട്ടിഫിക്കറ്റ് നമ്പർ",
  claimDetails: "ക്ലെയിം വിശദാംശങ്ങൾ",
  claim: "ക്ലെയിം",
  deathClaimType: "മരണം",
  diseaseClaimType: "ചികിത്സ",
  diseaseCategory: "രോഗ വിഭാഗം",
  dateOfIllness: "അസുഖം ആരംഭിച്ച തീയതി",
  hospitalCategory: "ആശുപത്രി വിഭാഗം",
  medicalCertIssuedBy: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് നൽകിയത്",
  medicalCertDate: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ് തീയതി",
  claimantName: "ആവശ്യപ്പെടുന്ന വ്യക്തിയുടെ നാമം.",
  relationshipToLoanee: "വായ്പക്കാരനുമായുള്ള ബന്ധം",
  specifyRelationship: "ബന്ധം വ്യക്തമാക്കുക",
  dateOfDeath: "മരണ തീയതി",
  deathCertificate: "മരണ സർട്ടിഫിക്കറ്റ് നമ്പർ",
  prevDiseaseRelief: "മുൻ രോഗ ആശ്വാസം",
  releaseAmount: "കൈപ്പറ്റിയ തുക",
  uploadedDocuments: "അപ്‌ലോഡ് ചെയ്ത രേഖകൾ",
  viewDoc: "രേഖ കാണുക",
  medicalCertificate: "മെഡിക്കൽ സർട്ടിഫിക്കറ്റ്",
  dobProof: "ജനനതീയതി തെളിവ്",
  dodProof: "മരണ തീയതി തെളിവ്",
  pleaseCheckDeclaration: "തുടരുന്നതിന് പ്രഖ്യാപനം ശരിയാണെന്ന് ഉറപ്പാക്കുക.",

};

export default ml;
